/** Static hero art per `live_events.key` (files in `public/events/`). */

export const EVENT_HERO_BY_KEY: Record<string, string> = {
  dessert_week: "/events/event-dessert-week.webp",
  spice_sprint: "/events/event-spice-sprint.webp",
  midnight_snack_rush: "/events/event-midnight-snack.webp",
};

/** Compact square icons for home menu floats (same keys as heroes). */
export const EVENT_MENU_ICON_BY_KEY: Record<string, string> = {
  dessert_week: "/events/event-icon-dessert-week.webp",
  spice_sprint: "/events/event-icon-spice-sprint.webp",
  midnight_snack_rush: "/events/event-icon-midnight-snack.webp",
};

/** Accent used for popup rim / chips when no dedicated theme. */
export const EVENT_POPUP_ACCENT: Record<string, string> = {
  dessert_week: "#ec4899",
  spice_sprint: "#ea580c",
  midnight_snack_rush: "#8b5cf6",
};

export function eventHeroImageSrc(eventKey: string | undefined): string | null {
  const k = (eventKey ?? "").trim();
  if (!k) return null;
  return EVENT_HERO_BY_KEY[k] ?? null;
}

/** Main-menu float: dedicated icon, else falls back to wide hero crop. */
export function eventMenuIconSrc(eventKey: string | undefined): string | null {
  const k = (eventKey ?? "").trim();
  if (!k) return null;
  return EVENT_MENU_ICON_BY_KEY[k] ?? null;
}

/** Home left-rail float: menu icon, else hero poster crop, else generic tab art. */
export function eventHomeFloatSrc(eventKey: string | undefined): string {
  const k = (eventKey ?? "").trim();
  if (!k) return "/events-tab-icon.webp";
  return (
    EVENT_MENU_ICON_BY_KEY[k] ??
    EVENT_HERO_BY_KEY[k] ??
    "/events-tab-icon.webp"
  );
}

export function eventPopupAccent(eventKey: string | undefined): string {
  const k = (eventKey ?? "").trim();
  return EVENT_POPUP_ACCENT[k] ?? "#258bd4";
}
